<template>
  <div class="w-full">
    <div
      v-if="showAddDeviceModal"  
      class="fixed inset-0 z-300 flex items-start justify-center bg-black bg-opacity-50 p-4 overflow-y-auto" 
    >
      <div 
        class="bg-white rounded-lg shadow-2xl relative w-full"
      >
      </div>
    </div>
    <div
      class="!rounded-t-lg bg-[#009A78] text-white 
             text-xl 4xl:text-[28px] 5xl:text-[36px] 
             font-medium p-3 4xl:p-6 5xl:p-8 
             text-start relative"
    >
      {{ mode === "edit" ? "Edit Device" : "Add New Device" }}

    </div>

    <div class="p-6 md:p-10 4xl:p-14 5xl:p-20 flex flex-col gap-5 4xl:gap-7 5xl:gap-10">
      <form autocomplete="off" class="grid grid-cols-1 md:grid-cols-2 gap-x-4 4xl:gap-x-6 5xl:gap-x-8 gap-y-5 4xl:gap-y-7 5xl:gap-y-10">
        
        <div class="col">
          <label 
            class="block text-[#009A78] text-base 4xl:!text-[22px] 5xl:!text-[30px] 
                   mb-2 4xl:mb-4 5xl:mb-5 font-normal" 
            for="Device-Type"
          >
            Application
          </label>
          <div class="relative custom-select">
            <select
              id="Device-Type"
              :class="{ '!bg-[#e9ecef]': mode === 'edit' }"
              class="form-select w-full h-[51px] 4xl:h-[65px] 5xl:h-[80px] 
                     px-3 4xl:px-5 5xl:px-6 
                     !rounded-lg !bg-[#F0F0F0] border-none appearance-none 
                     text-[16px] 4xl:!text-[22px] 5xl:!text-[30px] 
                     text-[#009a78] font-normal !bg-none"
              v-model="application"
              :disabled="mode === 'edit'"
            >
              <option
                v-for="option in applications"
                :key="option.value"
                :value="option.value"
              >
                {{ option.label }}
              </option>
            </select>
          </div>
        </div>
        
        <div class="col">
          <label 
            class="block text-[#009A78] text-base 4xl:text-[22px] 5xl:text-[30px] 
                   mb-2 4xl:mb-4 5xl:mb-5 font-normal flex justify-center items-center" 
            for="DeviceProfileID"
          >
            Device Profile ID
            <button
              class="bg-[#009a78] text-white text-center !text-[10px] 4xl:!text-base 5xl:!text-xl 
                     w-4 h-4 4xl:w-6 4xl:h-6 5xl:!w-7 5xl:!h-7 !rounded-full ml-1"
              type="button"
              data-bs-toggle="tooltip"
              title="This ID is provided by the system provider. Please contact your provider if needed."
            >
              i
            </button>
          </label>
          <input
          :class="{ '!bg-[#e9ecef]': mode === 'edit' }"
            class="form-control w-full h-[51px] 4xl:h-[65px] 5xl:h-[80px] 
                   px-3 4xl:px-5 5xl:px-6 
                   !rounded-lg !bg-[#F0F0F0] border border-gray-300 
                   focus:border-[#009A78] focus:ring-2 focus:ring-[#3b82f6] focus:!bg-white 
                   transition duration-150 text-[16px] 4xl:!text-[22px] 5xl:!text-[30px] 
                   text-[#000000] font-normal placeholder:text-[#9B9A9A]"
            id="DeviceProfileID"
            type="text"
            v-model="deviceProfileID"
            autocomplete="off"
            :disabled="mode === 'edit'"
          />
        </div>

        <template v-if="flag != 'import'">
          <div class="col">
            <label 
              class="block text-[#009A78] text-base 4xl:text-[22px] 5xl:text-[30px] 
                     mb-2 4xl:mb-4 5xl:mb-5 font-normal" 
              for="DeviceEUI"
            >
              Device EUI
              <button
              class="bg-[#009a78] text-white text-center !text-[10px] 4xl:!text-base 5xl:!text-xl 
                     w-4 h-4 4xl:w-6 4xl:h-6 5xl:!w-7 5xl:!h-7 !rounded-full ml-1"
              type="button"
              data-bs-toggle="tooltip"
              title="This ID is provided by the system provider. Please contact your provider if needed."
            >
              i
            </button>
            </label>
            <input
            :class="{ '!bg-[#e9ecef]': mode === 'edit' }"
  class="form-control w-full h-[51px] 4xl:h-[65px] 5xl:h-[80px] 
         px-3 4xl:px-5 5xl:px-6 
         !rounded-lg !bg-[#F0F0F0] border border-gray-300 
         focus:border-[#009A78] focus:ring-2 focus:ring-[#3b82f6] 
         focus:!bg-white
         transition duration-150 text-[16px] 4xl:!text-[22px] 5xl:!text-[30px] 
         text-[#000000] font-normal placeholder:text-[#9B9A9A]"
  id="DeviceEUI"
  type="text"
  v-model="deviceEUI"
  autocomplete="off"
  :disabled="mode === 'edit'"
/>
          </div>
          <div class="col">
            <label 
              class="block text-[#009A78] text-base 4xl:text-[22px] 5xl:text-[30px] 
                     mb-2 4xl:mb-4 5xl:mb-5 font-normal" 
              for="DeviceName"
            >
              Device Name
            </label>
            <input
              class="form-control w-full h-[51px] 4xl:h-[65px] 5xl:h-[80px] 
                     px-3 4xl:px-5 5xl:px-6 
                     !rounded-lg !bg-[#F0F0F0] border border-gray-300 
                     focus:border-[#009A78] focus:ring-2 focus:ring-[#3b82f6] focus:!bg-white
                     transition duration-150 text-[16px] 4xl:!text-[22px] 5xl:!text-[30px] 
                     text-[#000000] font-normal placeholder:text-[#9B9A9A]"
              id="DeviceName"
              type="text"
              v-model="deviceName"
              autocomplete="off"
            />
          </div>

          <div class="col">
            <label 
              class="block text-[#009A78] text-base 4xl:text-[22px] 5xl:text-[30px] 
                     mb-2 4xl:mb-4 5xl:mb-5 font-normal" 
              for="DeviceDesc"
            >
              Device Desc
            </label>
            <input
              class="form-control w-full h-[51px] 4xl:h-[65px] 5xl:h-[80px] 
                     px-3 4xl:px-5 5xl:px-6 
                     !rounded-lg !bg-[#F0F0F0] border border-gray-300 
                     focus:border-[#009A78] focus:ring-2 focus:ring-[#3b82f6] focus:!bg-white
                     transition duration-150 text-[16px] 4xl:!text-[22px] 5xl:!text-[30px] 
                     text-[#000000] font-normal placeholder:text-[#9B9A9A]"
              id="DeviceDesc"
              type="text"
              v-model="deviceDesc"
              autocomplete="off"
            />
          </div>
          <div class="col">
            <label 
              class="block text-[#009A78] text-base 4xl:text-[22px] 5xl:text-[30px] 
                     mb-2 4xl:mb-4 5xl:mb-5 font-normal" 
              for="DeviceType"
            >
              Device Type
            </label>
            <div class="relative custom-select">
              <select
                id="DeviceType"
                :class="{ '!bg-[#e9ecef]': mode === 'edit' }"
                class="form-select w-full h-[51px] 4xl:h-[65px] 5xl:h-[80px] 
                       px-3 4xl:px-5 5xl:px-6
                       !rounded-lg !bg-[#F0F0F0] border-none appearance-none 
                       text-[16px] 4xl:!text-[22px] 5xl:!text-[30px] 
                       text-[#009a78] font-normal !bg-none"
                v-model="deviceType"
                :disabled="mode === 'edit'"
              >
                <option
                  v-for="option in deviceTypeOptions"
                  :key="option.value"
                  :value="option.value"
                >
                  {{ option.label }}
                </option>
              </select>
            </div>
          </div>

          <div class="col">
            <label 
              class="block text-[#009A78] text-base 4xl:text-[22px] 5xl:text-[30px] 
                     mb-2 4xl:mb-4 5xl:mb-5 font-normal" 
              for="ConnectionType"
            >
              Connection Type
            </label>
            <div class="relative custom-select">
              <select
                id="ConnectionType"
                :class="{ '!bg-[#e9ecef]': mode === 'edit' }"
                class="form-select w-full h-[51px] 4xl:h-[65px] 5xl:h-[80px] 
                       px-3 4xl:px-5 5xl:px-6 
                       !rounded-lg !bg-[#F0F0F0] border-none appearance-none 
                       text-[16px] 4xl:!text-[22px] 5xl:!text-[30px] 
                       text-[#009a78] font-normal !bg-none"
                v-model="connectionType"
                :disabled="mode === 'edit'"
              >
                <option
                  v-for="option in connectionTypeOptions"
                  :key="option.value"
                  :value="option.value"
                >
                  {{ option.label }}
                </option>
              </select>
            </div>
          </div>
          <div class="col">
            <label 
              class="block text-[#009A78] text-base 4xl:text-[22px] 5xl:text-[30px] 
                     mb-2 4xl:mb-4 5xl:mb-5 font-normal" 
              for="DeviceBrand"
            >
              Device Brand
            </label>
            <input
              class="form-control w-full h-[51px] 4xl:h-[65px] 5xl:h-[80px] 
                     px-3 4xl:px-5 5xl:px-6 
                     !rounded-lg !bg-[#F0F0F0] border border-gray-300 
                     focus:border-[#009A78] focus:ring-2 focus:ring-[#3b82f6] focus:!bg-white
                     transition duration-150 text-[16px] 4xl:!text-[22px] 5xl:!text-[30px] 
                     text-[#000000] font-normal placeholder:text-[#9B9A9A]"
              id="DeviceBrand"
              type="text"
              v-model="deviceBrand"
              autocomplete="off"
            />
          </div>

          <div class="col">
            <label 
              class="block text-[#009A78] text-base 4xl:text-[22px] 5xl:text-[30px] 
                     mb-2 4xl:mb-4 5xl:mb-5 font-normal" 
              for="DeviceModel"
            >
              Device Model
            </label>
            <input
              class="form-control w-full h-[51px] 4xl:h-[65px] 5xl:h-[80px] 
                     px-3 4xl:px-5 5xl:px-6 
                     !rounded-lg !bg-[#F0F0F0] border border-gray-300 
                     focus:border-[#009A78] focus:ring-2 focus:ring-[#3b82f6] focus:!bg-white
                     transition duration-150 text-[16px] 4xl:!text-[22px] 5xl:!text-[30px] 
                     text-[#000000] font-normal placeholder:text-[#9B9A9A]"
              id="DeviceModel"
              type="text"
              v-model="deviceModel"
              autocomplete="off"
            />
          </div>
          <div class="col">
            <label 
              class="block text-[#009A78] text-base 4xl:text-[22px] 5xl:text-[30px] 
                     mb-2 4xl:mb-4 5xl:mb-5 font-normal" 
              for="Lantern"
            >
              Lantern
            </label>
            <div class="relative custom-select">
              <select 
                id="Lantern" 
                class="form-select w-full h-[51px] 4xl:h-[65px] 5xl:h-[80px] 
                       px-3 4xl:px-5 5xl:px-6 
                       !rounded-lg !bg-[#F0F0F0] border-none appearance-none 
                       text-[16px] 4xl:!text-[22px] 5xl:!text-[30px] 
                       text-[#009a78] font-normal !bg-none" 
                v-model="lantern"
              >
                <option
                  v-for="option in lanterns"
                  :key="option.value"
                  :value="option.value"
                >
                  {{ option.label }}
                </option>
              </select>
            </div>
          </div>
          <div class="col">
  <label 
    class="block text-[#009A78] text-base 4xl:text-[22px] 5xl:text-[30px] 
           mb-2 4xl:mb-4 5xl:mb-5 font-normal" 
    for="FormFactor"
  >
    Form Factor
  </label>
  <div class="relative custom-select">
    <select
      id="FormFactor"
      v-model="formFactor"
      class="form-select w-full h-[51px] 4xl:h-[65px] 5xl:h-[80px] 
             px-3 4xl:px-5 5xl:px-6 
             !rounded-lg !bg-[#F0F0F0] border-none appearance-none 
             text-[16px] 4xl:!text-[22px] 5xl:!text-[30px] 
             text-[#009a78] font-normal !bg-none"
    >
      <option value="" disabled selected hidden></option>
      <option
        v-for="option in formFactors"
        :key="option.value"
        :value="option.value"
      >
        {{ option.label }}
      </option>
    </select>
  </div>
</div>

          <div class="col">
            <label 
              class="block text-[#009A78] text-base 4xl:text-[22px] 5xl:text-[30px] 
                     mb-2 4xl:mb-4 5xl:mb-5 font-normal" 
              for="commDate"
            >
              Comm Date
            </label>
            <Datepicker
              class="datepicker-custom w-full h-[51px] 4xl:h-[65px] 5xl:h-[80px] 
                     !rounded-lg bg-[#F0F0F0] text-[#000000] font-normal 
                     text-[16px] 4xl:!text-[22px] 5xl:!text-[30px]"
              id="commDate"
              v-model="commDate"
              :enable-time-picker="false"
              placeholder="Select Comm Date"
            ></Datepicker>
          </div>
          
          <div class="col">
            <label 
              class="block text-[#009A78] text-base 4xl:text-[22px] 5xl:text-[30px] 
                     mb-2 4xl:mb-4 5xl:mb-5 font-normal" 
              for="Latitude"
            >
              Latitude
            </label>
            <input
              class="form-control w-full h-[51px] 4xl:h-[65px] 5xl:h-[80px] 
                     px-3 4xl:px-5 5xl:px-6 
                     !rounded-lg !bg-[#F0F0F0] border border-gray-300 
                     focus:border-[#009A78] focus:ring-2 focus:ring-[#3b82f6] focus:!bg-white
                     transition duration-150 text-[16px] 4xl:!text-[22px] 5xl:!text-[30px] 
                     text-[#000000] font-normal placeholder:text-[#9B9A9A]"
              id="Latitude"
              type="text"
              v-model="latitude"
              autocomplete="off"
            />
          </div>
          <div class="col">
            <label 
              class="block text-[#009A78] text-base 4xl:text-[22px] 5xl:text-[30px] 
                     mb-2 4xl:mb-4 5xl:mb-5 font-normal" 
              for="Longitude"
            >
              Longitude
            </label>
            <input
              class="form-control w-full h-[51px] 4xl:h-[65px] 5xl:h-[80px] 
                     px-3 4xl:px-5 5xl:px-6 
                     !rounded-lg !bg-[#F0F0F0] border border-gray-300 
                     focus:border-[#009A78] focus:ring-2 focus:ring-[#3b82f6] focus:!bg-white
                     transition duration-150 text-[16px] 4xl:!text-[22px] 5xl:!text-[30px] 
                     text-[#000000] font-normal placeholder:text-[#9B9A9A]"
              id="Longitude"
              type="text"
              v-model="longitude"
              autocomplete="off"
            />
          </div>
          
          <div class="col col-span-1 md:col-span-2" v-if="connectionType !== 'Cellular'">
            <label 
              class="block text-[#009A78] text-base 4xl:text-[22px] 5xl:text-[30px] 
                     mb-2 4xl:mb-4 5xl:mb-5 font-normal" 
              for="LoraAppKey"
            >
              Lora App Key
              <button
              class="bg-[#009a78] text-white text-center !text-[10px] 4xl:!text-base 5xl:!text-xl 
                     w-4 h-4 4xl:w-6 4xl:h-6 5xl:!w-7 5xl:!h-7 !rounded-full ml-1"
              type="button"
              data-bs-toggle="tooltip"
              title="This ID is provided by the system provider. Please contact your provider if needed."
            >
              i
            </button>
            </label>
            <input
            :class="{ '!bg-[#e9ecef]': mode === 'edit' }"
              class="form-control w-full h-[51px] 4xl:h-[65px] 5xl:h-[80px] 
                     px-3 4xl:px-5 5xl:px-6 
                     !rounded-lg !bg-[#F0F0F0] border border-gray-300 
                     focus:border-[#009A78] focus:ring-2 focus:ring-[#3b82f6] focus:!bg-white
                     transition duration-150 text-[16px] 4xl:!text-[22px] 5xl:!text-[30px] 
                     text-[#000000] font-normal placeholder:text-[#9B9A9A]"
              id="LoraAppKey"
              type="text"
              v-model="loraAppKey"
              autocomplete="off"
              :disabled="mode === 'edit'"
            />
          </div>
        </template>
        
        <template v-if="flag == 'import'">
          <div class="col col-span-1 md:col-span-2">
            <label 
              class="block text-[#009A78] text-base 4xl:text-[22px] 5xl:text-[30px] 
                     mb-2 4xl:mb-4 5xl:mb-5 font-normal" 
              for="csvFile"
            >
              Upload CSV
            </label>
            <input
              type="file"
              id="csvFile"
              accept=".csv"
              @change="handleFileUpload"
              class="w-full h-[51px] 4xl:h-[65px] 5xl:h-[80px] 
                     px-3 4xl:px-5 5xl:px-6
                     !rounded-lg bg-[#F0F0F0] border border-gray-300 
                     focus:border-[#009A78] focus:ring-2 focus:ring-[#3b82f6] 
                     transition duration-150 text-[16px] 4xl:!text-[22px] 5xl:!text-[30px] 
                     text-[#000000] font-normal placeholder:text-[#9B9A9A]"
            />

            <div v-if="csvData.length" class="mt-5 4xl:mt-7 5xl:mt-10">
              <label 
                class="block text-[#009A78] text-base 4xl:text-[22px] 5xl:text-[30px] 
                       mb-2 4xl:mb-4 5xl:mb-5 font-normal"
              >
                Parsed CSV Data:
              </label>
              <div style="overflow-x: auto">
                <table class="w-full border-collapse text-[14px] 4xl:text-[18px] 5xl:text-[24px]">
                  <thead>
                    <tr class="border border-gray-300">
                      <th v-for="(header, index) in csvData[0]" :key="index" class="p-2 4xl:p-3 5xl:p-4 border border-gray-300 bg-gray-100">
                        {{ header }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(row, rowIndex) in csvData.slice(1)"
                      :key="rowIndex"
                      class="border border-gray-300 hover:bg-gray-50"
                    >
                      <td v-for="(cell, cellIndex) in row" :key="cellIndex" class="p-2 4xl:p-3 5xl:p-4 border border-gray-300">
                        {{ cell }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          
          <div class="col col-span-1 md:col-span-2">
            <a
              href="/csv/csv_example.csv"
              download="example.csv"
              class="text-blue-600 hover:text-blue-800 text-base 4xl:text-[22px] 5xl:text-[30px] font-medium"
            >
              Download CSV Example
            </a>
          </div>
          
          <div class="col col-span-1 md:col-span-2 mt-2 4xl:mt-4 5xl:mt-6">
            <ul
              class="!list-disc pl-5 text-black text-sm 4xl:text-base 5xl:text-xl space-y-2 4xl:space-y-3 5xl:space-y-4"
            >
              <li>
                The Device EUI, Device Profile ID, and LoRa App Key ID are
                provided by Vectolabs.
              </li>
              <li>
                Please contact Vectolabs to obtain the correct options for the
                following fields: Application ID, Device Type ID, Connection
                Type ID, Lantern ID, and Form Factor ID. These values are
                normally selected from dropdown menus, but must be entered
                manually in the CSV file.
              </li>
            </ul>
          </div>
        </template>
        
      </form>
    </div>

    <div
      class="p-6 md:p-10 4xl:p-14 5xl:p-20 
             flex flex-col gap-5 4xl:gap-7 5xl:gap-9 
             border-t border-gray-200 !rounded-b-lg"
    >
      <button
        class="w-full h-[51px] 4xl:!h-[72px] 5xl:!h-[104px] 
               !rounded-lg 5xl:!rounded-2xl bg-[#009A78] text-white 
               text-base 4xl:!text-[22px] 5xl:!text-[30px] 
               font-normal hover:bg-[#00795e] transition duration-200"
        type="button"
        @click="handleSave()"
      >
        Save
      </button>

      <button
        v-show="mode === 'edit'"
        class="w-full h-[51px] 4xl:!h-[72px] 5xl:!h-[104px] 
               !rounded-lg 5xl:!rounded-2xl bg-[#FF9700] text-white 
               text-base 4xl:!text-[22px] 5xl:!text-[30px] 
               font-normal hover:bg-[#cc7a00] transition duration-200"
        type="button"
        @click="handleDelete"
      >
        Delete
      </button>
    </div>
  </div>
</template>

<script>
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import moment from "moment";

export default {
  components: {
    Datepicker,
  },
  props: ["isEdit", "formEdit", "flag"],
  watch: {
    deviceModel() {
      // console.log(this.deviceModel);
    },
    isEdit: {
      handler: function (val) {
        this.mode = val ? "edit" : "add";
        // console.log(val);
        this.application = val ? this.formEdit.Application : "";
        this.deviceProfileID = val ? this.formEdit.DeviceProfileID : "";
        this.deviceEUI = val ? this.formEdit.DeviceEUI : "";
        this.deviceDesc = val ? this.formEdit.Description : "";
        this.deviceType = val ? this.formEdit.DeviceTypeID : "";
        this.deviceBrand = val ? this.formEdit.DeviceBrand : "";
        this.deviceModel = val ? this.formEdit.DeviceModel : "";
        this.lantern = val ? this.formEdit.Lantern : "";
        this.formFactor = val ? this.formEdit.FormFactor : "";
        this.commDate = val ? this.formEdit.CommDate : "";
        this.latitude = val ? this.formEdit.Latitude : "";
        this.longitude = val ? this.formEdit.Longitude : "";
        this.connectionType = val ? this.formEdit.ConnectionType : "";
        this.deviceType = val ? this.formEdit.DeviceType : "";
        this.deviceName = val ? this.formEdit.DeviceName : "";
        this.deviceID = val ? this.formEdit.DeviceID : "";
        this.loraAppKey = val ? this.formEdit.LoraAppKey : "";
        this.connectedCluster = val ? this.formEdit.ConnectedCluster : "";
      },
      deep: true,
      immediate: true, 
    },
    formEdit(val) {
      // console.log(val);
      this.mode = this.isEdit ? "edit" : "add";
      this.application = val.Application;
      this.deviceProfileID = val.DeviceProfileID;
      this.deviceEUI = val.DeviceEUI;
      this.deviceDesc = val.Description;
      this.deviceType = val.DeviceTypeID;
      this.deviceBrand = val.DeviceBrand;
      this.deviceModel = val.DeviceModel;
      this.lantern = val.Lantern;
      this.formFactor = val.FormFactor;
      this.commDate = val.CommDate;
      this.latitude = val.Latitude;
      this.longitude = val.Longitude;
      this.connectionType = val.ConnectionTypeID;
      this.deviceType = val.DeviceTypeID;
      this.deviceName = val.DeviceName;
      // this.deviceID = val.DeviceID;
      this.loraAppKey = val.LoraAppKey;
      // this.connectedCluster = val.ConnectedCluster;
    },
  },
  data() {
    return {
      csvData: [],
      mode: "add",
      // connectionType: "LoraWAN",
      connectionType: "",

      deviceName: "",
      deviceID: "",
      loraAppKey: "",
      connectedCluster: "",
      connectionTypeOptions: [
        { label: "LoraWAN", value: "LoraWAN" }, // Changed to be object for consistency, using strings for now
        { label: "Cellular", value: "Cellular" }
      ],

      connectedClusterOptions: ["Cluster A", "Cluster B"],
      application: "",
      applications: [
        {
          label: "Application A",
          value: "AppA",
        },
      ],
      deviceProfileID: "",
      deviceEUI: "",
      deviceDesc: "",
      deviceType: "",
      deviceTypeOptions: [],
      deviceBrand: "",
      deviceModel: "",
      lantern: "",
      lanterns: [],
      formFactor: "",
      formFactors: [],
      commDate: "",
      latitude: "",
      longitude: "",
    };
  },
  emits: ["closeModal", "onDelete", "onSave"],
  methods: {
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file && file.type === "text/csv") {
        const reader = new FileReader();
        reader.onload = (e) => {
          const text = e.target.result;
          this.csvData = this.parseCSV(text);
        };
        reader.readAsText(file);
      } else {
        alert("Please upload a valid CSV file.");
      }
    },
    parseCSV(text) {
      // console.log(text);
      return text
        .trim()
        .split("\n")
        .filter(
          (line) =>
            line.trim() !== "" &&
            line.split(",").some((cell) => cell.trim() !== "")
        ) // Skip empty or blank rows
        .map((line) => line.split(","));
      // .trim()
      // .split("\n")
      // .map((line) => line.split(","));
    },
    formatDateRange(dateRange) {
      // console.log(dat);
      if (Array.isArray(dateRange)) {
        return dateRange.map(this.formatDate).join(" - ");
      }
      return "";
    },
    getFormFactor() {
      this.formFactors = [];
      this.$http.get(":11005/api/v1/formfactor").then((res) => {
        if (!res.error) {
          let response = res.message;
          // console.log(response);
          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].formfactorname,
              value: response[i].formfactorid,
            };
            this.formFactors.push(obj);
          }
        }
      });
    },
    getLantern() {
      this.lanterns = [];
      this.$http.get(":11005/api/v1/lantern").then((res) => {
        if (!res.error) {
          let response = res.message;
          // console.log(response);

          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].model,
              value: response[i].lanternid,
            };
            this.lanterns.push(obj);
          }
        }
      });
    },
    getApplication() {
      this.applications = [];

      this.$http.get(":11005/api/v1/application").then((res) => {
        if (!res.error) {
          let response = res.message;
          // console.log(response);

          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].AppName,
              value: response[i].AppId,
            };
            this.applications.push(obj);
          }
        }
      });
    },
    // handleSelectedType(option) {
    //   this.connectionType = option;
    // },
    closeModal() {
      this.resetForm();
      this.$emit("closeModal");
    },
    handleSave() {
      // console.log(this.mode.toUpperCase());
      let obj = {};
      if (this.mode.toUpperCase() == "ADD") {
        if (this.flag == "import") {
          const mappedData = this.csvData.slice(1).map((row) => ({
            Deveui: row[0],
            DeviceName: row[1],
            DeviceDesc: row[2],
            DeviceTypeID: parseInt(row[3]),
            ConnTypeID: parseInt(row[4]),
            DeviceBrand: row[5],
            DeviceModel: row[6],
            LanternID: row[7],
            FormFactorID: parseInt(row[8]),
            CommDate: moment(row[9]).format("YYYY-MM-DD"),
            Latitude: parseFloat(row[10]),
            Longitude: parseFloat(row[11]),
            Warranty: moment(row[12]).format("YYYY-MM-DD"),
            FirmwareRev: row[13],
            TopboardRev: row[14],
            BottomboardRev: row[15],
            AppKey: row[16].trim(),
          }));
          obj = {
            ApplicationId: this.application,
            DeviceProfileId: this.deviceProfileID,
            Device: mappedData,
          };
        } else {
          obj = {
            ApplicationId: this.application,
            DeviceProfileId: this.deviceProfileID,
            Device: [
              {
                Deveui: this.deviceEUI, //keyin
                DeviceName: this.deviceName, //keyin
                DeviceDesc: this.deviceDesc, //keyin - optional
                DeviceTypeID: this.deviceType, //dropdown
                ConnTypeID: this.connectionType, //dropdown
                DeviceBrand: this.deviceBrand, //keyin - optional
                DeviceModel: this.deviceModel, //keyin - optional
                LanternID: this.lantern, //dropdown
                FormFactorID: this.formFactor, //dropdown - optional
                CommDate: moment(this.commDate).format("YYYY-MM-DD"), //keyin
                Latitude: parseFloat(this.latitude), //keyin
                Longitude: parseFloat(this.longitude), //keyin
                Warranty: "2027-02-01", //keyin - optional
                FirmwareRev: "1.2.3", //keyin - optional
                TopboardRev: "1.2.4", //keyin - optional
                BottomboardRev: "1.2.21", //keyin - optional
                AppKey: this.loraAppKey, //keyin
              },
            ],
          };
        }
      }

      if (this.mode.toUpperCase() == "EDIT") {
        obj = {
          ApplicationId: this.application,
          DeviceProfileId: this.deviceProfileID,
          Deveui: this.deviceEUI, //keyin
          DeviceName: this.deviceName, //keyin
          DeviceDesc: this.deviceDesc, //keyin - optional
          DeviceBrand: this.deviceBrand, //keyin - optional
          DeviceModel: this.deviceModel, //keyin - optional
          LanternID: this.lantern, //dropdown
          FormFactorID: this.formFactor, //dropdown - optional
          CommDate: moment(this.commDate).format("YYYY-MM-DD"), //keyin
          Latitude: parseFloat(this.latitude), //keyin
          Longitude: parseFloat(this.longitude), //keyin
          Warranty: "2027-02-01", //keyin - optional
          FirmwareRev: "1.2.3", //keyin - optional
          TopboardRev: "1.2.4", //keyin - optional
          BottomboardRev: "1.2.21", //keyin - optional
        };
      }

      // console.log(obj);
      this.$emit(
        "onSave",
        obj,
        this.mode.toUpperCase() == "EDIT" ? this.deviceEUI : ""
      );
      this.resetForm();
    },
    handleDelete() {
      // // console.log(this.deviceEUI)

      this.$emit("onDelete", this.deviceEUI);
      this.resetForm();
    },
    resetForm() {
      // this.connectionType = "LoraWAN";
      this.connectionType = "";
      this.loraAppKey = "";
      this.deviceEUI = "";
      this.deviceType = "";
      this.deviceName = "";
      this.application = "";
      this.deviceProfileID = "";

      this.loraAppKey = "";
      this.connectedCluster = "";

      this.deviceDesc = "";

      this.deviceBrand = "";
      this.deviceModel = "";
      this.lantern = "";
      this.formFactor = "";
      this.commDate = "";
      this.latitude = "";
      this.longitude = "";
      this.csvData = [];
    },
    getDeviceType() {
      this.deviceTypeOptions = [];
      this.$http.get(":11005/api/v1/devtype").then((res) => {
        if (!res.error) {
          let response = res.message;
          // console.log(response);

          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].devicetypename,
              value: response[i].devicetypeid,
            };
            this.deviceTypeOptions.push(obj);
          }
        }
      });
    },
    getConnectionType() {
      this.$http.get(":11005/api/v1/conntype").then((res) => {
        if (!res.error) {
          let response = res.message;
          // console.log(response);
          this.connectionTypeOptions = [];
          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].conntypename,
              value: response[i].conntypeid,
            };
            this.connectionTypeOptions.push(obj);
          }
        }
      });
    },
  },
  mounted() {
    this.getApplication();
    this.getConnectionType();
    this.getDeviceType();
    this.getLantern();
    this.getFormFactor();
  },
};
</script>

<style lang="scss" scoped>
// Inherit/replicate the styles from the holidays modal for consistency
.custom-select::after {
  content: "▼";
  position: absolute;
  right: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: #009a78; 
  font-size: 16px; /* Default size */
}

// Global datepicker styling to match the holidays modal input field look
.datepicker-custom {
  .dp__input_wrap {
    height: 100%;
  }
  .dp__input {
    height: 100%;
    border: none;
    border-radius: 8px;
    background: #f0f0f0;
    color: #000000 !important;
    font-weight: 400 !important;
    font-size: 16px;
    padding: 0.75rem 1rem; /* Adjusted for better alignment */
    font-family: inherit;
    &::placeholder {
      color: #9b9a9a !important;
      font-weight: 400 !important;
    }
  }
  .dp__input:focus {
    box-shadow: 0 0 0 1px #3b82f6 !important;
    border-color: #3b82f6 !important;
    outline: none;
  }
}

// Responsive Styles (Replicated from Holidays Modal CSS)
@media (min-width: 2560px) {
  .custom-select::after {
    font-size: 22px; 
    right: 1.5rem;
  }
  .datepicker-custom {
    .dp__input {
      font-size: 22px !important;
      padding: 1.2rem 1.5rem !important; 
    }
  }
}

@media (min-width: 3840px) {
  .custom-select::after {
    font-size: 30px; 
    right: 2rem;
  }
  .datepicker-custom {
    .dp__input {
      font-size: 30px !important;
      padding: 1.8rem 2rem !important; 
    }
  }
}
</style>